import { BiXCircle } from "react-icons/bi";
import Button from "../../components/Button";
import { Recipe } from "../../store/backend";

import MessageModal, { MessageModalProps } from "../../components/MessageModal";
import { useState } from "react";
import StepItem from "./StepItem";
import { calcProgramStepsDuration } from "../../utils";


export type RecipeDetailModalProps = {
  isOpen?: boolean;
  recipe?: Recipe
  onCancel?(): void;
  onStart?(recipeId: string): void
  startButtonDisabled?: boolean
};


type BodyViewParams = {
  type: 'A'
  title: string
  subTitle: string
} | {
  type: 'B'
  title: string
  subTitle: string
  label: string
}

export function RecipeDetailModal(props: RecipeDetailModalProps) {

  const [startMessageModel, setStartMessageModel] = useState<MessageModalProps>()

  if (!props.isOpen || !props.recipe) {
    return <div />;
  }


  const onDisabled = (recipe: Recipe) => {
    setStartMessageModel({
      isOpen: true,
      title: `Stop current running and load new program?`,
      buttons: [
        {
          text: 'YES', onAction: () => {
            setStartMessageModel(e => ({ ...e || {}, isOpen: false }))
            props.onStart && props.onStart(recipe.id)
          },
          style: {
            backgroundColor: '#5ede4e',
          }
        },

        { text: 'NO', onAction: () => setStartMessageModel(e => ({ ...e || {}, isOpen: false })) },

      ],
    })
  }


  const onStart = (recipe: Recipe) => {
    setStartMessageModel({
      isOpen: true,
      title: `Starting ${recipe.name} fermentation program!\n\nTemperature: ${recipe.temperature}°C\nDuration: ${recipe.duration}\n\nThe fermentation chamber will now begin the program.`,
      buttons: [
        {
          text: 'YES', onAction: () => {
            setStartMessageModel(e => ({ ...e || {}, isOpen: false }))
            props.onStart && props.onStart(recipe.id)
          },
          style: {
            backgroundColor: '#5ede4e',
          }
        },

        { text: 'NO', onAction: () => setStartMessageModel(e => ({ ...e || {}, isOpen: false })) },

      ],
    })


  }


  const titleView = (type:
    'ingredients' |
    'steps' |
    'tips', title: string) => {

    const iconText = type === 'ingredients'
      ? '🥄'
      : type === 'steps'
        ? '📋'
        : '💡'

    return (
      <div
        className="flex"
        style={{
          margin: 20,
          alignItems: 'center',
        }}
      >
        <div
          style={{
            marginRight: 10,
            fontSize: 24,
          }}
        >{iconText}</div>
        <div
          style={{
            fontSize: 20,
            fontWeight: 'bold',
            color: '#fbc785',
          }}
        >{title}</div>
      </div>
    )
  }



  const bodyView = (params: BodyViewParams, color: string, style?: React.CSSProperties,) => {

    const body = () => {
      switch (params.type) {

        case 'A': {
          return (
            <div
              style={{
                backgroundColor: "rgba(255, 255, 255, 0.1)",
                marginLeft: 20,
                marginRight: 20,
                padding: 12,
                borderRadius: 8,
                borderLeft: `4px solid ${color}`,
                ...style || {},
              }}
            >
              <div
                style={{
                  fontWeight: 'bold',
                  marginBottom: 8,
                  color: '#fbc785',
                }}
              >
                {params.title}
              </div>
              <div
                style={{
                  marginBottom: 8,
                  lineHeight: 1.4,
                }}
              >
                {params.subTitle}
              </div>
            </div>
          )
        }

        case 'B': {
          return (
            <div
              style={{
                backgroundColor: "rgba(255, 255, 255, 0.1)",
                marginLeft: 20,
                marginRight: 20,
                padding: 12,
                borderRadius: 8,
                borderLeft: `4px solid ${color}`,
                ...style || {},
              }}
            >
              <div
                style={{
                  fontWeight: 'bold',
                  marginBottom: 4,
                }}
              >
                {params.title}
              </div>
              <div
                style={{
                  marginBottom: 4,
                  color: '#fbc785',
                }}
              >
                {params.label}
              </div>
              <div
                style={{
                  fontStyle: 'italic',
                  opacity: 0.8,
                  fontSize: 14,
                }}
              >
                {params.subTitle}
              </div>
            </div>
          )
        }
      }
    }


    return (
      <div>
        {body()}
      </div>
    )

  }

  return (
    <div
      className="flex fixed top-0 left-0 h-full w-full"
      style={{
        backgroundColor: 'rgba(0,0,0,0.5)',
      }}
    >

      <div
        onClick={(e) => {
          e.stopPropagation();
        }}
        style={{
          flex: 1,
          flexDirection: 'column',
          margin: '70px 140px',
          justifyContent: "center",
          alignItems: "center",
          position: 'relative',
        }}
      >

        <BiXCircle
          onClick={props.onCancel}
          style={{
            position: 'absolute',
            color: "white",
            fontSize: 40,
            right: 20,
            top: 20,
          }}
        />

        <div>
          <div
            style={{
              backgroundColor: '#2c5253',
              padding: 20,
              borderRadius: '16px 16px 0 0',
              color: 'white',
              flexDirection: 'column',
            }}
          >
            <div
              style={{
                fontSize: 28,
                fontWeight: 'bold',
                marginBottom: 10,
              }}
            >
              {props.recipe.name}
            </div>
            <div
              style={{
                fontSize: 16,
                opacity: 0.9,
              }}
            >
              {props.recipe.description}
            </div>
          </div>

          <div
            style={{
              flex: 1,
              overflowY: 'auto',
              backgroundColor: '#406F70',
              maxHeight: '70vh',
              color: 'white',
              borderRadius: '0px 0px 16px 16px',

            }}
          >

            <div className="flex flex-col w-[720px] rounded-[20px] ml-[20px] mt-[20px]" style={{ borderColor: '#000000', borderWidth: 1, backgroundColor: '#9FB7B7' }}>

              <div className="grid grid-cols-2 gap-x-[20px] gap-y-[20px]  p-[20px] pb-[0px]">
                {props.recipe.programSteps.map((item, index) => {
                  return (
                    <StepItem key={index} programStep={item} />
                  )
                })}
              </div>

              <div className="flex space-x-[2px] bg-[white] rounded-full mt-[40px]" style={{ overflow: 'hidden', alignSelf: 'center', width: 130 * props.recipe.programSteps.length }}>
                {props.recipe.programSteps.map((item, index) => {
                  return (
                    <div style={{ textAlign: 'center', lineHeight: 1.1 }}
                      className={`text-[24px] flex-1 h-[28px] ${`bg-stepColor${index + 1}`}`} key={index}>{index + 1}</div>
                  )
                })}
              </div>

              <div className="text-[20] font-bold text-center mt-[5px] mb-[20px]" >Total time - {calcProgramStepsDuration(props.recipe.programSteps)} </div>

            </div>

            <div>
              {titleView('ingredients', 'Ingredients')}
              {props.recipe.ingredients.map((item, index) => {
                return (
                  <div
                    key={index}
                  >
                    {bodyView({ type: 'B', label: item.amount, subTitle: item.notes, title: item.name }, '#f79225', { marginTop: index === 0 ? 0 : 8 })}
                  </div>
                )
              })}
              {titleView('steps', 'Preparation Steps')}
              {props.recipe.steps.map((item, index) => {
                return (
                  <div
                    key={index}
                  >
                    {bodyView({ type: 'A', subTitle: item.description, title: `${index + 1}. ${item.title}` }, '#3F89CE', { marginTop: index === 0 ? 0 : 8 })}
                  </div>
                )
              })}
              {titleView('tips', 'Tips & Fine-tuning')}
              {props.recipe.tips.map((item, index) => {
                return (
                  <div
                    key={index}
                  >
                    {bodyView({ type: 'A', subTitle: item.description, title: item.title }, '#BB389F', { marginTop: index === 0 ? 0 : 8 })}
                  </div>
                )
              })}



            </div>

            <Button
              options={{
                text: "🚀 START FERMENTATION PROGRAM",
                cb: () => {
                  if (props.startButtonDisabled) {
                    props.recipe && onDisabled(props.recipe)

                  } else {
                    props.recipe && onStart(props.recipe)

                  }
                }
                // disabled: props.startButtonDisabled,
              }}
              style={{
                opacity: props.startButtonDisabled ? 0.5 : 1,
                boxShadow: "4px 4px 4px  rgba(0, 0, 0, 0.3)",
                backgroundColor: "#488238",
                marginLeft: "55px",
                // border: 'none',
                borderRadius: 8,
                fontSize: 20,
                fontWeight: 'bold',
                cursor: 'pointer',
                margin: 20,
                transition: 'all 0.2s',
              }}
            />

          </div>


        </div>

      </div>

      {startMessageModel && (<MessageModal {...startMessageModel} />)}

    </div >
  );
}

